import { useEffect } from "react";

export default function FacebookFeed() {
  useEffect(() => {
    if (!window.FB) {
      const script = document.createElement("script");

      script.src =
        "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v23.0";

      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";

      document.body.appendChild(script);
    } else {
      window.FB.XFBML.parse();
    }
  }, []);

  return (
    <div className="w-full flex justify-center">
      <div
        className="fb-page"
        data-href="https://www.facebook.com/hopbonpremium/"
        data-tabs="timeline"
        data-height="900"
        data-adapt-container-width="true"
      />
    </div>
  );
}